
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/notkunarskilmalar",
      function () {
        return require("private-next-pages/um/fyrirtaekid/notkunarskilmalar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/notkunarskilmalar"])
      });
    }
  